import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface ConcreteKBEIconProps {
  size?: number;
  color?: string;
}

const ConcreteKBEIcon: React.FC<ConcreteKBEIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-concretekbe">
    {
      <path d="M13.985 3.571h-9.594l0.155 16.857h13.313l1.75-6.578h-5.679l0.055-10.279z"></path>

    }  </SvgIcon>
);

export default ConcreteKBEIcon;
